import { render, staticRenderFns } from "./IntegrationsDraggableTable.vue?vue&type=template&id=49cd2a26&scoped=true&"
import script from "./IntegrationsDraggableTable.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsDraggableTable.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationsDraggableTable.vue?vue&type=style&index=0&id=49cd2a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd2a26",
  null
  
)

export default component.exports